import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.from-entries.js";
import classNames$1 from 'classnames';
import { useCheckbox as useCheckbox$1 } from '@react-aria/checkbox';
import { useHover as useHover$1 } from '@react-aria/interactions';
import { VisuallyHidden } from '@react-aria/visually-hidden';
import { useFocusableRef } from '@react-spectrum/utils';
import { useToggleState } from '@react-stately/toggle';
import * as React from 'react';
import React__default, { isValidElement, useRef, createElement, Fragment, createContext, useContext, useMemo, cloneElement, useState, forwardRef } from 'react';
import { useMenu as useMenu$1, useMenuSection, useMenuItem as useMenuItem$1, useMenuTrigger as useMenuTrigger$1 } from '@react-aria/menu';
import { useTreeState } from '@react-stately/tree';
import { Item, Section, useMenuTriggerState } from 'react-stately';
import { useSeparator, usePress, useHover as useHover$2, useFocusable, mergeProps as mergeProps$1, useListBoxSection, useOverlay, useOverlayPosition, FocusScope, DismissButton } from 'react-aria';
import { useMenuTriggerState as useMenuTriggerState$1 } from '@react-stately/menu';
import { useListBox, useOption } from '@react-aria/listbox';
import { useSelect as useSelect$1, HiddenSelect } from '@react-aria/select';
import { useSelectState } from '@react-stately/select';
import ReactDOM__default, { createPortal } from 'react-dom';
import { useFocusRing } from '@react-aria/focus';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function notNil(x) {
  return x != null;
}

function pick(obj) {
  var res = {};

  for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
    var key = _keys[_i];

    if (key in obj) {
      res[key] = obj[key];
    }
  }

  return res;
}

function pickBy(obj, func) {
  var res = {};

  for (var _i2 = 0, _Object$entries = Object.entries(obj); _i2 < _Object$entries.length; _i2++) {
    var _Object$entries$_i = _Object$entries[_i2],
        key = _Object$entries$_i[0],
        val = _Object$entries$_i[1];

    if (func(key, val)) {
      res[key] = obj[key];
    }
  }

  return res;
}

function omit(obj) {
  var res = {};

  for (var _len2 = arguments.length, keys = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    keys[_key2 - 1] = arguments[_key2];
  }

  for (var _i3 = 0, _Object$keys = Object.keys(obj); _i3 < _Object$keys.length; _i3++) {
    var key = _Object$keys[_i3];

    if (!keys.includes(key)) {
      res[key] = obj[key];
    }
  }

  return res;
}

function isSubset(a1, a2) {
  return a1.every(function (x) {
    return a2.includes(x);
  });
}

function chainSingleArgFuncs() {
  for (var _len3 = arguments.length, funcs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    funcs[_key3] = arguments[_key3];
  }

  if (funcs.length === 0) {
    return undefined;
  }

  return function (arg) {
    var res = arg;

    for (var _iterator = _createForOfIteratorHelperLoose(funcs), _step; !(_step = _iterator()).done;) {
      var func = _step.value;
      res = func(res);
    }

    return res;
  };
}

function isString(x) {
  return typeof x === "string";
}

function groupBy(collection, keyFunc) {
  var result = {};

  for (var _iterator2 = _createForOfIteratorHelperLoose(collection), _step2; !(_step2 = _iterator2()).done;) {
    var obj = _step2.value;
    var key = keyFunc(obj);

    if (key in result) {
      result[key].push(obj);
    } else {
      result[key] = [obj];
    }
  }

  return result;
}

function mapValues(obj, mapper) {
  var result = {};

  for (var key in obj) {
    result[key] = mapper(obj[key]);
  }

  return result;
}

var isBrowser = typeof window !== "undefined";
var NONE = /*#__PURE__*/Symbol("NONE");
var useIsomorphicLayoutEffect = isBrowser ? React__default.useLayoutEffect : React__default.useEffect;

function createElementWithChildren(elementType, props, children) {
  if (Array.isArray(children)) {
    return React__default.createElement.apply(React__default, [elementType, props].concat(children));
  } else if (children || "children" in props) {
    // Only call React.createElement with `children` if there are actual children,
    // or if there was an explicit (albeit undefined) children passed via
    // props.  Otherwise, if you pass `undefined` as the children argument
    // to React.createElement, the created element will have prop {children: undefined}.
    // If the `root` is an PlasmicGeneratedComponent, and these props with {children: undefined}
    // are used, then it will be taken as a `children` override, and will thus blank out
    // everything under the root node.
    return React__default.createElement(elementType, props, children);
  } else {
    return React__default.createElement(elementType, props);
  }
}

function ensureNotArray(children) {
  if (Array.isArray(children)) {
    return React__default.createElement.apply(React__default, [React__default.Fragment, {}].concat(children));
  } else {
    return children;
  }
}
/**
 * Flattens ReactNode into an array of ReactChild, but does NOT replace
 * missing keys with array index, as React.Children.toArray() does.
 */


function toChildArray(children) {
  if (isReactChild(children)) {
    return [children];
  } else if (Array.isArray(children)) {
    return children.flatMap(toChildArray);
  } else {
    return [];
  }
}

function isReactText(child) {
  return typeof child === "string" || typeof child === "number";
}

function isReactChild(child) {
  return React__default.isValidElement(child) || isReactText(child);
}

function isReactNode(x) {
  return typeof x === "string" || typeof x === "number" || React__default.isValidElement(x);
}

function mergeProps(props) {
  var result = _extends({}, props);

  for (var _len = arguments.length, restProps = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    restProps[_key - 1] = arguments[_key];
  }

  for (var _i = 0, _restProps = restProps; _i < _restProps.length; _i++) {
    var rest = _restProps[_i];

    for (var _i2 = 0, _Object$keys = Object.keys(rest); _i2 < _Object$keys.length; _i2++) {
      var key = _Object$keys[_i2];
      result[key] = mergePropVals(key, result[key], rest[key]);
    }
  }

  return result;
}

function updateRef(ref, value) {
  if (!ref) {
    return;
  }

  if (typeof ref === "function") {
    ref(value);
  } else {
    if (!Object.isFrozen(ref)) {
      ref.current = value;
    }
  }
}

function mergeRefs() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }

  return function (value) {
    for (var _iterator = _createForOfIteratorHelperLoose(refs), _step; !(_step = _iterator()).done;) {
      var ref = _step.value;
      updateRef(ref, value);
    }
  };
}

function mergePropVals(name, val1, val2) {
  if (val1 === NONE || val2 === NONE) {
    // The NONE sentinel always skips all merging and returns null
    return null;
  } else if (val1 == null) {
    // If either of them is nil, prefer the other
    return val2;
  } else if (val2 == null) {
    return val1;
  } else if (name === "className") {
    // Special case for className -- always combine both class names
    return classNames$1(val1, val2);
  } else if (name === "style") {
    // Special case for style -- always shallow-merge style dicts
    return _extends({}, val1, val2);
  } else if (name === "ref") {
    // Special case for ref
    return mergeRefs(val1, val2);
  } else if (typeof val1 !== typeof val2) {
    // If the type of the two values are different, then no way to merge them.
    // Prefer val2.
    return val2;
  } else if (name.startsWith("on") && typeof val1 === "function") {
    // Special case for event handlers -- always call both handlers
    return function () {
      var res;

      if (typeof val1 === "function") {
        res = val1.apply(void 0, arguments);
      }

      if (typeof val2 === "function") {
        res = val2.apply(void 0, arguments);
      }

      return res;
    };
  } else {
    // For all else, prefer val2
    return val2;
  }
}

function getElementTypeName(comp) {
  if (typeof comp === "string") {
    return comp;
  } else {
    var _comp$displayName;

    return (_comp$displayName = comp.displayName) != null ? _comp$displayName : "Component";
  }
}

var PLUME_STRICT_MODE = true;

function setPlumeStrictMode(mode) {
  PLUME_STRICT_MODE = mode;
}

function mergeVariantToggles() {
  for (var _len = arguments.length, toggles = new Array(_len), _key = 0; _key < _len; _key++) {
    toggles[_key] = arguments[_key];
  }

  var definedToggles = toggles.filter(function (x) {
    return !!x.def;
  });
  var grouped = groupBy(definedToggles, function (_ref) {
    var def = _ref.def;
    return def.group;
  });
  return mapValues(grouped, function (subToggles) {
    return Object.fromEntries(subToggles.map(function (_ref2) {
      var def = _ref2.def,
          active = _ref2.active;
      return [def.variant, !!active];
    }));
  });
}

function noOutline() {
  return {
    outline: "none"
  };
}

function getPlumeType(child) {
  if (isValidElement(child)) {
    return child.type.__plumeType;
  }

  return undefined;
}

function getStyleProps(props) {
  return pick(props, "className", "style");
}

function getDefaultPlasmicProps(plasmicClass, props) {
  return {
    plasmicProps: {
      variants: pick.apply(void 0, [props].concat(plasmicClass.internalVariantProps)),
      args: pick.apply(void 0, [props].concat(plasmicClass.internalArgProps)),
      overrides: {}
    }
  };
}

var RE_DATA_PROP = /^(data-.*)$/;

function getDataProps(props) {
  return pickBy(props, function (k) {
    return RE_DATA_PROP.test(k);
  });
}

function asAriaCheckboxProps(props) {
  var ariaProps = _extends({}, props, {
    isSelected: props.isChecked,
    defaultSelected: props.defaultChecked
  });

  delete ariaProps["isChecked"];
  delete ariaProps["defaultChecked"];
  return ariaProps;
}

function useCheckbox(plasmicClass, props, config, ref) {
  var _overrides, _ref;

  if (ref === void 0) {
    ref = null;
  }

  var children = props.children,
      isDisabled = props.isDisabled,
      isIndeterminate = props.isIndeterminate;
  var inputRef = useRef(null);
  var domRef = useFocusableRef(ref, inputRef);
  var ariaProps = asAriaCheckboxProps(props);
  var state = useToggleState(ariaProps);

  var _useHover = useHover$1(props),
      hoverProps = _useHover.hoverProps;

  var _useAriaCheckbox = useCheckbox$1(ariaProps, state, inputRef),
      inputProps = _useAriaCheckbox.inputProps;

  var variants = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalVariantProps)), mergeVariantToggles({
    def: config.isDisabledVariant,
    active: isDisabled
  }, {
    def: config.isCheckedVariant,
    active: state.isSelected
  }, {
    def: config.isIndeterminateVariant,
    active: isIndeterminate
  }, {
    def: config.noLabelVariant,
    active: !children
  }));

  var overrides = (_overrides = {}, _overrides[config.root] = {
    as: "label",
    props: mergeProps(hoverProps, getStyleProps(props), {
      ref: domRef
    }),
    wrapChildren: function wrapChildren(children) {
      return createElement(Fragment, null, createElement(VisuallyHidden, {
        isFocusable: true
      }, createElement("input", Object.assign({}, inputProps, {
        ref: inputRef
      }))), children);
    }
  }, _overrides);

  var args = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalArgProps)), config.labelSlot ? (_ref = {}, _ref[config.labelSlot] = children, _ref) : {});

  return {
    plasmicProps: {
      variants: variants,
      overrides: overrides,
      args: args
    },
    state: state
  };
}
/**
 * In general, we try not to expose react-aria's Collections API to Plume users.
 * The Collections API is how react-aria users pass data about collections of
 * things using the built-in Item and Section components, which are abstract,
 * metadata-only components that don't render anything but only serve to specify
 * data.  For example, here's how you would use react-spectrum's Picker:
 *
 *   <Picker>
 *     <Section title="Asia">
 *       <Item key="taiwan">Taiwan</Item>
 *       <Item key="japan">Japan</Item>
 *       <Item key="china">China</Item>
 *     </Section>
 *     <Section title="Europe">
 *       <Item key="germany">Germany</Item>
 *       <Item key="france">France</Item>
 *     </Section>
 *   </Picker>
 *
 * You would re-use this same Item/Section components to pass similar things to
 * Menu, Tabs, etc.
 *
 * For Plasmic, this API is too abstract.  The user has explicitly designed components
 * like Select.Option and Select.OptionGroup, and it is weird that they don't actually
 * use these components. It is more natural to do:
 *
 *   <Select>
 *     <Select.OptionGroup title="Asia">
 *       <Select.Option key="taiwan">Taiwan</Select>
 *     </Select.OptionGroup>
 *   </Select>
 *
 * For Plume, we let users directly use the components they designed, both to collect
 * information and to perform actual rendering.  For example, for Plume,
 * you'd use Select.Option instead of Item, and Select.OptionGroup instead of Section.
 * This means that the Select.Option props will collect the same information Item
 * does.
 *
 * A component like Select.Option then serves two purposes:
 *
 * 1. Allow users to specify the collection of data, like in the above example
 *    Here, we're mainly interested in the props in those ReactElements so
 *    we can pass the Item/Section data onto react-aria's APIs.  We are not
 *    actually rendering these elements.
 * 2. Once react-aria's Collections API has gone through them and built
 *    Collection "nodes", we then create cloned versions of these elements
 *    with the corresponding node passed in as a secret prop.  These ReactElements
 *    are then actually used to _render_ the corresponding Option / OptionGroup.
 *
 * This file contains helper functions to help with implementing the above.
 *
 * Note also that most of the collections-based react-aria components expose
 * a parallel API that accepts a list of "items" and a render prop, instead
 * of list of Item/Section elements.  This is for efficiency, but we are opting
 * to only support the composite-component pattern for now for simplicity.
 */

/**
 * Given children of a component like Select or Menu, derive the items
 * that we will pass into the Collections API.  These will be
 * ReactElement<ItemLikeProps|SectionLikeProps>[].
 *
 * Will also assign keys to items by their index in the collection,
 * and collect the keys of disabled items.
 */


function deriveItemsFromChildren(children, opts) {
  if (!children) {
    return {
      items: [],
      disabledKeys: []
    };
  }

  var itemPlumeType = opts.itemPlumeType,
      sectionPlumeType = opts.sectionPlumeType,
      invalidChildError = opts.invalidChildError; // For Plume items without an explicit key, we assign a key as the index
  // of the collection.

  var itemCount = 0;
  var sectionCount = 0;

  var ensureValue = function ensureValue(element) {
    if (!("value" in element.props)) {
      if (opts.requireItemValue && PLUME_STRICT_MODE) {
        throw new Error("Must specify a \"value\" prop for " + getElementTypeName(element.type));
      } else {
        return React__default.cloneElement(element, {
          value: "" + itemCount++
        });
      }
    } else {
      // Still increment count even if key is present, so that the
      // auto-assigned key really reflects the index
      itemCount++;
      return element;
    }
  };

  var disabledKeys = [];

  var flattenedChildren = function flattenedChildren(children) {
    return toChildArray(children).flatMap(function (child) {
      if (React__default.isValidElement(child)) {
        if (child.type === React__default.Fragment) {
          return flattenedChildren(child.props.children);
        }

        var type = getPlumeType(child);

        if (type === itemPlumeType) {
          child = ensureValue(child);
          var childKey = getItemLikeKey(child);

          if (child.props.isDisabled && !!childKey) {
            disabledKeys.push(childKey);
          }

          return [child];
        }

        if (type === sectionPlumeType) {
          var _child$key;

          return [React__default.cloneElement(child, {
            // key of section doesn't actually matter, just needs
            // to be unique
            key: (_child$key = child.key) != null ? _child$key : "section-" + sectionCount++,
            children: flattenedChildren(child.props.children)
          })];
        }
      }

      if (PLUME_STRICT_MODE) {
        throw new Error(invalidChildError != null ? invalidChildError : "Unexpected child");
      } else {
        return [];
      }
    });
  };

  return {
    items: flattenedChildren(children),
    disabledKeys: disabledKeys
  };
}
/**
 * Given a Collection node, create the React element that we should use
 * to render it.
 */


function renderCollectionNode(node) {
  // node.rendered should already have our item-like or section-like Plume
  // component elements, so we just need to clone them with a secret
  // _node prop that we use to render.
  if (node.hasChildNodes) {
    return React__default.cloneElement(node.rendered, {
      _node: node
    });
  } else {
    return React__default.cloneElement(node.rendered, {
      _node: node
    });
  }
}
/**
 * Renders a item-like or section-like Plume component element into an
 * Item or a Section element.
 */


function renderAsCollectionChild(child, opts) {
  var plumeType = getPlumeType(child);

  if (plumeType === opts.itemPlumeType) {
    var _option$props$textVal;

    var option = child; // We look at the children passed to the item-like element, and derive key
    // or textValue from it if it is a string

    var content = option.props.children; // The children render prop needs to return an <Item/>

    return React__default.createElement(Item // We use ItemLike.value if the user explicitly specified a value,
    // and we fallback to key.  If the user specified neither, then
    // the Collections API will generate a unique key for this item.
    , {
      // We use ItemLike.value if the user explicitly specified a value,
      // and we fallback to key.  If the user specified neither, then
      // the Collections API will generate a unique key for this item.
      key: getItemLikeKey(option),
      // textValue is either explicitly specified by the user, or we
      // try to derive it if `content` is a string.
      textValue: (_option$props$textVal = option.props.textValue) != null ? _option$props$textVal : isString(content) ? content : option.props.value ? "" + option.props.value : option.key ? "" + option.key : undefined,
      "aria-label": option.props["aria-label"]
    }, option);
  } else {
    var group = child;
    return React__default.createElement(Section // Note that we are using the whole section-like element as the title
    // here, and not group.props.title; we want the entire section-like
    // Plume element to end up as Node.rendered.
    , {
      // Note that we are using the whole section-like element as the title
      // here, and not group.props.title; we want the entire section-like
      // Plume element to end up as Node.rendered.
      title: group,
      "aria-label": group.props["aria-label"],
      // We are flattening and deriving the descendant Options as items here.
      // group.props.children should've already been cleaned up by
      // deriveItemsFromChildren()
      items: group.props.children
    }, function (c) {
      return renderAsCollectionChild(c, opts);
    });
  }
}

function getItemLikeKey(element) {
  var _element$props$value;

  return (_element$props$value = element.props.value) != null ? _element$props$value : element.key;
}

var TriggeredOverlayContext = /*#__PURE__*/createContext(undefined);
var MenuContext = /*#__PURE__*/createContext(undefined);
var COLLECTION_OPTS = {
  itemPlumeType: "menu-item",
  sectionPlumeType: "menu-group"
};
/**
 * Converts props from BaseMenuProps to react-aria's useMenu() props.
 */

function asAriaMenuProps(props) {
  var children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["children"]);

  var _deriveItemsFromChild = deriveItemsFromChildren(children, _extends({}, COLLECTION_OPTS, {
    invalidChildError: "Can only use Menu.Item and Menu.Group as children to Menu",
    requireItemValue: false
  })),
      items = _deriveItemsFromChild.items,
      disabledKeys = _deriveItemsFromChild.disabledKeys;

  return {
    ariaProps: _extends({}, rest, {
      children: function children(child) {
        return renderAsCollectionChild(child, COLLECTION_OPTS);
      },
      items: items,
      disabledKeys: disabledKeys
    })
  };
}

function useMenu(plasmicClass, props, config, ref) {
  var _overrides, _extends2;

  if (ref === void 0) {
    ref = null;
  }

  var _asAriaMenuProps = asAriaMenuProps(props),
      ariaProps = _asAriaMenuProps.ariaProps;

  var triggerContext = useContext(TriggeredOverlayContext);
  var state = useTreeState(ariaProps);
  var menuListRef = useRef(null);

  var _useAriaMenu = useMenu$1(_extends({}, ariaProps, {
    autoFocus: triggerContext == null ? void 0 : triggerContext.autoFocus
  }), state, menuListRef),
      menuProps = _useAriaMenu.menuProps;

  var contextValue = useMemo(function () {
    return {
      state: state,
      menuProps: props
    };
  }, [state, props]);

  var variants = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalVariantProps)));

  var overrides = (_overrides = {}, _overrides[config.root] = {
    props: mergeProps(getStyleProps(props), {
      ref: ref
    })
  }, _overrides[config.itemsContainer] = {
    as: "ul",
    props: mergeProps(menuProps, {
      ref: menuListRef,
      style: _extends({}, noOutline())
    })
  }, _overrides);

  var args = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalArgProps)), (_extends2 = {}, _extends2[config.itemsSlot] = createElement(MenuContext.Provider, {
    value: contextValue
  }, Array.from(state.collection).map(function (node) {
    return renderCollectionNode(node);
  })), _extends2));

  return {
    plasmicProps: {
      variants: variants,
      args: args,
      overrides: overrides
    }
  };
}

function useMenuGroup(plasmicClass, props, config) {
  var _extends2, _overrides;

  var context = useContext(MenuContext);
  var node = props._node;

  if (!context || !node) {
    if (PLUME_STRICT_MODE) {
      throw new Error("You can only use a Menu.Group within a Menu component.");
    }

    return getDefaultPlasmicProps(plasmicClass, props);
  }

  var _useMenuSection = useMenuSection({
    heading: props.title,
    "aria-label": props["aria-label"]
  }),
      headingProps = _useMenuSection.headingProps,
      groupProps = _useMenuSection.groupProps;

  var _useSeparator = useSeparator({
    elementType: "li"
  }),
      separatorProps = _useSeparator.separatorProps;

  var variants = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalVariantProps)), mergeVariantToggles({
    def: config.noTitleVariant,
    active: !props.title
  }, {
    def: config.isFirstVariant,
    active: context.state.collection.getFirstKey() === node.key
  }));

  var args = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalArgProps)), (_extends2 = {}, _extends2[config.titleSlot] = props.title, _extends2[config.itemsSlot] = Array.from(node.childNodes).map(function (childNode) {
    return renderCollectionNode(childNode);
  }), _extends2));

  var overrides = (_overrides = {}, _overrides[config.root] = {
    props: getStyleProps(props)
  }, _overrides[config.separator] = {
    props: _extends({}, separatorProps),
    as: "li"
  }, _overrides[config.titleContainer] = _extends({
    props: _extends({
      role: "presentation"
    }, headingProps)
  }, !props.title && {
    render: function render() {
      return null;
    }
  }), _overrides[config.itemsContainer] = {
    props: _extends({}, groupProps),
    as: "ul"
  }, _overrides);
  return {
    plasmicProps: {
      variants: variants,
      args: args,
      overrides: overrides
    }
  };
}

function useMenuItem(plasmicClass, props, config) {
  var _extends2, _overrides;

  var menuContext = useContext(MenuContext);
  var triggerContext = useContext(TriggeredOverlayContext);

  if (!menuContext) {
    if (PLUME_STRICT_MODE) {
      throw new Error("You can only use a Menu.Item within a Menu component.");
    }

    return getDefaultPlasmicProps(plasmicClass, props);
  }

  var children = props.children,
      onAction = props.onAction;
  var state = menuContext.state,
      menuProps = menuContext.menuProps; // We pass in the Node secretly as an undocumented prop from <Select />

  var node = props._node;
  var isDisabled = state.disabledKeys.has(node.key);
  var isHighlighted = state.selectionManager.isFocused && state.selectionManager.focusedKey === node.key;
  var ref = useRef(null);

  var _useAriaMenuItem = useMenuItem$1(mergeProps({
    // We need to merge both the onAction on MenuItem and the onAction
    // on Menu
    onAction: onAction
  }, {
    onAction: menuProps.onAction,
    onClose: triggerContext == null ? void 0 : triggerContext.state.close
  }, {
    isDisabled: isDisabled,
    "aria-label": node && node["aria-label"],
    key: node.key,
    isVirtualized: false,
    closeOnSelect: true
  }), state, ref),
      menuItemProps = _useAriaMenuItem.menuItemProps,
      labelProps = _useAriaMenuItem.labelProps;

  var variants = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalVariantProps)), mergeVariantToggles({
    def: config.isDisabledVariant,
    active: isDisabled
  }, {
    def: config.isHighlightedVariant,
    active: isHighlighted
  }));

  var args = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalArgProps)), (_extends2 = {}, _extends2[config.labelSlot] = children, _extends2));

  var overrides = (_overrides = {}, _overrides[config.root] = {
    as: "li",
    props: mergeProps(menuItemProps, {
      ref: ref,
      style: noOutline()
    })
  }, _overrides[config.labelContainer] = {
    props: _extends({}, labelProps)
  }, _overrides);
  return {
    plasmicProps: {
      variants: variants,
      args: args,
      overrides: overrides
    }
  };
}
/**
 * A menu trigger hook that combines react-aria's useMenuTrigger, useAriaMenuTrigger,
 * useOverlayPosition, useOverlay, and usePress
 */


function useMenuTrigger(opts, state) {
  var triggerRef = opts.triggerRef,
      isDisabled = opts.isDisabled,
      placement = opts.placement,
      menuMatchTriggerWidth = opts.menuMatchTriggerWidth,
      menuWidth = opts.menuWidth,
      menu = opts.menu;

  var _useAriaMenuTrigger = useMenuTrigger$1({
    type: "menu",
    isDisabled: isDisabled
  }, state, triggerRef),
      triggerPressProps = _useAriaMenuTrigger.menuTriggerProps,
      menuProps = _useAriaMenuTrigger.menuProps;

  var _usePress = usePress(triggerPressProps),
      triggerProps = _usePress.pressProps;

  var makeMenu = function makeMenu() {
    var realMenu = typeof menu === "function" ? menu() : menu;

    if (!realMenu) {
      return null;
    }

    if (getPlumeType(realMenu) !== "menu") {
      if (PLUME_STRICT_MODE) {
        throw new Error("Must use an instance of the Menu component.");
      }

      return null;
    }

    return cloneElement(realMenu, mergeProps(realMenu.props, menuProps));
  };

  var triggerContext = useMemo(function () {
    var _state$focusStrategy;

    return {
      triggerRef: triggerRef,
      state: state,
      autoFocus: (_state$focusStrategy = state.focusStrategy) != null ? _state$focusStrategy : true,
      placement: placement,
      overlayMatchTriggerWidth: menuMatchTriggerWidth,
      overlayMinTriggerWidth: true,
      overlayWidth: menuWidth
    };
  }, [triggerRef, state, placement, menuMatchTriggerWidth, menuWidth]);
  return {
    triggerProps: triggerProps,
    makeMenu: makeMenu,
    triggerContext: triggerContext
  };
}

function DropdownMenu(props) {
  var isOpen = props.isOpen,
      defaultOpen = props.defaultOpen,
      onOpenChange = props.onOpenChange,
      children = props.children,
      placement = props.placement,
      menu = props.menu;
  var triggerRef = useRef(null);
  var state = useMenuTriggerState({
    isOpen: isOpen,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange,
    shouldFlip: true
  });

  var _useMenuTrigger = useMenuTrigger({
    triggerRef: triggerRef,
    placement: placement,
    menu: menu
  }, state),
      triggerProps = _useMenuTrigger.triggerProps,
      makeMenu = _useMenuTrigger.makeMenu,
      triggerContext = _useMenuTrigger.triggerContext;

  return createElement(TriggeredOverlayContext.Provider, {
    value: triggerContext
  }, cloneElement(children, mergeProps(children.props, triggerProps, {
    ref: triggerRef
  })), state.isOpen && makeMenu());
}

function useMenuButton(plasmicClass, props, config, outerRef) {
  var _extends2, _overrides;

  if (outerRef === void 0) {
    outerRef = null;
  }

  var placement = props.placement,
      isOpen = props.isOpen,
      defaultOpen = props.defaultOpen,
      onOpenChange = props.onOpenChange,
      isDisabled = props.isDisabled,
      menu = props.menu,
      autoFocus = props.autoFocus,
      menuMatchTriggerWidth = props.menuMatchTriggerWidth,
      menuWidth = props.menuWidth;
  var triggerRef = useRef(null);
  var onTriggerRef = mergeRefs(triggerRef, outerRef);
  var state = useMenuTriggerState$1({
    isOpen: isOpen,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange,
    shouldFlip: true
  });

  var _useMenuTrigger = useMenuTrigger({
    isDisabled: isDisabled,
    triggerRef: triggerRef,
    placement: placement,
    menuMatchTriggerWidth: menuMatchTriggerWidth,
    menuWidth: menuWidth,
    menu: menu
  }, state),
      triggerProps = _useMenuTrigger.triggerProps,
      makeMenu = _useMenuTrigger.makeMenu,
      triggerContext = _useMenuTrigger.triggerContext;

  var _useHover = useHover$2(props),
      triggerHoverProps = _useHover.hoverProps;

  var _useFocusable = useFocusable(props, triggerRef),
      triggerFocusProps = _useFocusable.focusableProps;

  var variants = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalVariantProps)), mergeVariantToggles({
    def: config.isOpenVariant,
    active: state.isOpen
  }, {
    def: config.isDisabledVariant,
    active: isDisabled
  }));

  var args = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalArgProps)), (_extends2 = {}, _extends2[config.menuSlot] = state.isOpen ? makeMenu() : undefined, _extends2));

  var overrides = (_overrides = {}, _overrides[config.root] = {
    wrapChildren: function wrapChildren(children) {
      return createElement(TriggeredOverlayContext.Provider, {
        value: triggerContext
      }, children);
    }
  }, _overrides[config.trigger] = {
    props: mergeProps(triggerProps, triggerHoverProps, triggerFocusProps, getStyleProps(props), pick(props, "title"), {
      ref: onTriggerRef,
      autoFocus: autoFocus,
      disabled: !!isDisabled
    })
  }, _overrides);
  var plumeState = {
    open: function open() {
      return state.open();
    },
    close: function close() {
      return state.close();
    },
    isOpen: function isOpen() {
      return state.isOpen;
    }
  };
  return {
    plasmicProps: {
      variants: variants,
      args: args,
      overrides: overrides
    },
    state: plumeState
  };
}

var SelectContext = /*#__PURE__*/createContext(undefined);
var COLLECTION_OPTS$1 = {
  itemPlumeType: "select-option",
  sectionPlumeType: "select-option-group"
};
/**
 * Converts props in our BaseSelectProps into props that react-aria's
 * useSelect() understands.
 *
 * Because we're not exposing the Collections API (see ./index.tsx),
 * we are converting our own API into props for useSelect.
 *
 * Specifically, in Plume's API,
 * - `children` flattens to a list of ReactElements of type Select.Option
 *   or Select.OptionGroup
 *
 * and we map it this way to the Collections API:
 * - `items` is a list of those flattened ReactElements from `children`!
 * - `children`, as a render prop, is supposed to take one of the `items`
 *   and return a `Section` or `Item` element. We take an Option/OptionGroup
 *   element, and use its props to render the appropriate `Section` or
 *   `Item`. The "trick" here is that we then stuff the Option element as
 *   `Item.children`, and the OptionGroup element as `Section.title`.
 *
 * When the Collections API does its work deriving `Node`s, the corresponding
 * Option/OptionGroup ReactElements will end up as `Node.rendered`.
 *
 * Then, when we are actually rendering the content of the dropdown, we
 * iterate through each collected `Node`, and renders
 * React.cloneElement(Node.rendered, {_node: node}).  This "secretly" passes
 * the derived collection `Node` as a prop to Option and OptionGroup, and they
 * can make use of the derived `Node.key` etc in their rendering functions.
 *
 * One thing to note here is that we never "rendered" the Option/OptionGroup
 * React elements that the user constructed; instead, we just looked at the
 * props used on those elements, and passed those onto the Collections API.
 * What gets rendered to the screen is the cloned version of these elements
 * with the secret derived `_node` prop.  That means Option and OptionGroup
 * render functions can assume that _node is passed in.
 */

function asAriaSelectProps(props) {
  var value = props.value,
      defaultValue = props.defaultValue,
      children = props.children,
      onChange = props.onChange,
      rest = _objectWithoutPropertiesLoose(props, ["value", "defaultValue", "children", "onChange", "placement", "menuMatchTriggerWidth", "menuWidth"]);

  var _deriveItemsFromChild = deriveItemsFromChildren(children, _extends({}, COLLECTION_OPTS$1, {
    invalidChildError: "Can only use Select.Option and Select.OptionGroup as children to Select",
    requireItemValue: true
  })),
      items = _deriveItemsFromChild.items,
      disabledKeys = _deriveItemsFromChild.disabledKeys;

  return {
    ariaProps: _extends({}, rest, {
      children: function children(child) {
        return renderAsCollectionChild(child, COLLECTION_OPTS$1);
      },
      onSelectionChange: onChange ? function (val) {
        onChange(val != null ? val : null);
      } : onChange,
      items: items,
      disabledKeys: disabledKeys,
      defaultSelectedKey: defaultValue
    }, "value" in props && {
      selectedKey: value != null ? value : null
    })
  };
}

function useSelect(plasmicClass, props, config, ref) {
  var _overrides, _extends2;

  if (ref === void 0) {
    ref = null;
  }

  var _asAriaSelectProps = asAriaSelectProps(props),
      ariaProps = _asAriaSelectProps.ariaProps;

  var placement = props.placement;
  var state = useSelectState(ariaProps);
  var triggerRef = useRef(null);
  var rootRef = useFocusableRef(ref, triggerRef);
  var isDisabled = props.isDisabled,
      name = props.name,
      menuWidth = props.menuWidth,
      menuMatchTriggerWidth = props.menuMatchTriggerWidth,
      autoFocus = props.autoFocus,
      placeholder = props.placeholder,
      selectedContent = props.selectedContent;

  var _useAriaSelect = useSelect$1(ariaProps, state, triggerRef),
      triggerPressProps = _useAriaSelect.triggerProps,
      menuProps = _useAriaSelect.menuProps;

  var _usePress = usePress(triggerPressProps),
      triggerProps = _usePress.pressProps;

  var _useHover = useHover$2(ariaProps),
      triggerHoverProps = _useHover.hoverProps;

  var triggerContent = state.selectedItem ? selectedContent != null ? selectedContent : state.selectedItem.value.props.children : null;

  var variants = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalVariantProps)), mergeVariantToggles({
    def: config.isOpenVariant,
    active: state.isOpen
  }, {
    def: config.placeholderVariant,
    active: !state.selectedItem
  }, {
    def: config.isDisabledVariant,
    active: isDisabled
  }));

  var triggerContext = useMemo(function () {
    return {
      triggerRef: triggerRef,
      state: state,
      placement: placement,
      overlayMatchTriggerWidth: menuMatchTriggerWidth,
      overlayMinTriggerWidth: true,
      overlayWidth: menuWidth
    };
  }, [triggerRef, state, placement, menuMatchTriggerWidth, menuWidth]);
  var overrides = (_overrides = {}, _overrides[config.root] = {
    props: mergeProps$1(getStyleProps(props), {
      ref: rootRef
    }),
    wrapChildren: function wrapChildren(children) {
      return createElement(Fragment, null, createElement(HiddenSelect, {
        state: state,
        triggerRef: triggerRef,
        name: name,
        isDisabled: isDisabled
      }), children);
    }
  }, _overrides[config.trigger] = {
    props: mergeProps$1(triggerProps, triggerHoverProps, {
      ref: triggerRef,
      autoFocus: autoFocus,
      disabled: !!isDisabled
    })
  }, _overrides[config.overlay] = {
    wrap: function wrap(content) {
      return createElement(TriggeredOverlayContext.Provider, {
        value: triggerContext
      }, content);
    }
  }, _overrides[config.optionsContainer] = {
    wrap: function wrap(content) {
      return createElement(ListBoxWrapper, {
        state: state,
        menuProps: menuProps
      }, content);
    }
  }, _overrides);

  var args = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalArgProps)), (_extends2 = {}, _extends2[config.triggerContentSlot] = triggerContent, _extends2[config.placeholderSlot] = placeholder, _extends2[config.optionsSlot] = createElement(SelectContext.Provider, {
    value: state
  }, Array.from(state.collection).map(function (node) {
    return renderCollectionNode(node);
  })), _extends2));

  var plumeState = {
    open: function open() {
      return state.open();
    },
    close: function close() {
      return state.close();
    },
    isOpen: function isOpen() {
      return state.isOpen;
    },
    getSelectedValue: function getSelectedValue() {
      return state.selectedKey ? "" + state.selectedKey : null;
    },
    setSelectedValue: function setSelectedValue(key) {
      return state.setSelectedKey(key);
    }
  };
  return {
    plasmicProps: {
      variants: variants,
      args: args,
      overrides: overrides
    },
    state: plumeState
  };
}

function ListBoxWrapper(props) {
  var state = props.state,
      menuProps = props.menuProps,
      children = props.children;
  var ref = useRef(null);

  var _useListBox = useListBox(_extends({}, menuProps, {
    isVirtualized: false,
    autoFocus: state.focusStrategy || true,
    disallowEmptySelection: true
  }), state, ref),
      listBoxProps = _useListBox.listBoxProps;

  return cloneElement(children, mergeProps$1(children.props, listBoxProps, {
    style: noOutline(),
    ref: ref
  }));
}

function useSelectOption(plasmicClass, props, config, outerRef) {
  var _extends2, _overrides;

  if (outerRef === void 0) {
    outerRef = null;
  }

  var state = useContext(SelectContext);

  if (!state) {
    // If no context, then we are being incorrectly used.  Complain or just don't
    // bother installing any hooks.  It's okay to violate rules of hooks here
    // because this instance won't suddenly be used correctly in another render.
    if (PLUME_STRICT_MODE) {
      throw new Error("You can only use a Select.Option within a Select component.");
    }

    return getDefaultPlasmicProps(plasmicClass, props);
  }

  var children = props.children; // We pass in the Node secretly as an undocumented prop from <Select />

  var node = props._node;
  var isSelected = state.selectionManager.isSelected(node.key);
  var isDisabled = state.disabledKeys.has(node.key);
  var isHighlighted = state.selectionManager.isFocused && state.selectionManager.focusedKey === node.key;
  var ref = useFocusableRef(outerRef);

  var _useAriaOption = useOption({
    isSelected: isSelected,
    isDisabled: isDisabled,
    "aria-label": node && node["aria-label"],
    key: node.key,
    shouldSelectOnPressUp: true,
    shouldFocusOnHover: true,
    isVirtualized: false
  }, state, ref),
      optionProps = _useAriaOption.optionProps,
      labelProps = _useAriaOption.labelProps;

  var variants = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalVariantProps)), mergeVariantToggles({
    def: config.isSelectedVariant,
    active: isSelected
  }, {
    def: config.isDisabledVariant,
    active: isDisabled
  }, {
    def: config.isHighlightedVariant,
    active: isHighlighted
  }));

  var args = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalArgProps)), (_extends2 = {}, _extends2[config.labelSlot] = children, _extends2));

  var overrides = (_overrides = {}, _overrides[config.root] = {
    props: mergeProps(optionProps, getStyleProps(props), {
      ref: ref,
      style: noOutline()
    })
  }, _overrides[config.labelContainer] = {
    props: labelProps
  }, _overrides);
  return {
    plasmicProps: {
      variants: variants,
      args: args,
      overrides: overrides
    }
  };
}

function useSelectOptionGroup(plasmicClass, props, config) {
  var _extends2, _overrides;

  var state = useContext(SelectContext); // `node` should exist if the OptionGroup was instantiated properly
  // within a Select

  var node = props._node;

  if (!state || !node) {
    if (PLUME_STRICT_MODE) {
      throw new Error("You can only use a Select.OptionGroup within a Select component.");
    }

    return getDefaultPlasmicProps(plasmicClass, props);
  }

  var _useListBoxSection = useListBoxSection({
    heading: props.title,
    "aria-label": props["aria-label"]
  }),
      headingProps = _useListBoxSection.headingProps,
      groupProps = _useListBoxSection.groupProps;

  var _useSeparator = useSeparator({
    elementType: "li"
  }),
      separatorProps = _useSeparator.separatorProps;

  var variants = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalVariantProps)), mergeVariantToggles({
    def: config.noTitleVariant,
    active: !props.title
  }, {
    def: config.isFirstVariant,
    active: state.collection.getFirstKey() === node.key
  }));

  var args = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalArgProps)), (_extends2 = {}, _extends2[config.titleSlot] = props.title, _extends2[config.optionsSlot] = Array.from(node.childNodes).map(function (childNode) {
    return renderCollectionNode(childNode);
  }), _extends2));

  var overrides = (_overrides = {}, _overrides[config.root] = {
    props: getStyleProps(props)
  }, _overrides[config.separator] = {
    props: _extends({}, separatorProps)
  }, _overrides[config.titleContainer] = _extends({
    props: _extends({
      role: "presentation"
    }, headingProps)
  }, !props.title && {
    render: function render() {
      return null;
    }
  }), _overrides[config.optionsContainer] = {
    props: _extends({}, groupProps)
  }, _overrides);
  return {
    plasmicProps: {
      variants: variants,
      args: args,
      overrides: overrides
    }
  };
}

function useTriggeredOverlay(plasmicClass, props, config, outerRef) {
  var _extends2, _overrides;

  if (outerRef === void 0) {
    outerRef = null;
  }

  var overlayRef = useRef(null);
  var onOverlayRef = mergeRefs(overlayRef, outerRef);
  var context = useContext(TriggeredOverlayContext);

  if (!context) {
    // If no context, then we are not being correctly used.  Either complain, or
    // exit early.  It's okay to exit early and break the rules of React hooks
    // because we won't suddenly have the appropriate context anyway for this instance.
    if (PLUME_STRICT_MODE) {
      throw new Error("You can only use a triggered overlay with a TriggeredOverlayContext");
    }

    return getDefaultPlasmicProps(plasmicClass, props);
  }

  var children = props.children;
  var triggerRef = context.triggerRef,
      placement = context.placement,
      overlayMatchTriggerWidth = context.overlayMatchTriggerWidth,
      overlayMinTriggerWidth = context.overlayMinTriggerWidth,
      overlayWidth = context.overlayWidth,
      state = context.state; // Measure the width of the trigger to inform the width of the menu (below).

  var _React$useState = useState(false),
      isRendered = _React$useState[0],
      setRendered = _React$useState[1];

  var triggerWidth = triggerRef.current && (overlayMatchTriggerWidth || overlayMinTriggerWidth) ? triggerRef.current.offsetWidth : undefined;
  useIsomorphicLayoutEffect(function () {
    if (!isRendered && triggerRef.current && (overlayMatchTriggerWidth || overlayMinTriggerWidth)) {
      setRendered(true);
    }
  }, [triggerRef, isRendered, overlayMatchTriggerWidth, overlayMinTriggerWidth]);

  var _useOverlay = useOverlay({
    isOpen: state.isOpen,
    onClose: state.close,
    isDismissable: true,
    shouldCloseOnBlur: true
  }, overlayRef),
      overlayAriaProps = _useOverlay.overlayProps;

  var _useOverlayPosition = useOverlayPosition({
    targetRef: triggerRef,
    overlayRef: overlayRef,
    placement: placement != null ? placement : "bottom left",
    shouldFlip: true,
    isOpen: state.isOpen,
    onClose: state.close,
    containerPadding: 0
  }),
      overlayPositionProps = _useOverlayPosition.overlayProps,
      updatePosition = _useOverlayPosition.updatePosition,
      placementAxis = _useOverlayPosition.placement;

  useIsomorphicLayoutEffect(function () {
    if (state.isOpen) {
      requestAnimationFrame(function () {
        updatePosition();
      });
    }
  }, [state.isOpen, updatePosition]);
  var overlayProps = mergeProps({
    style: {
      left: "auto",
      right: "auto",
      top: "auto",
      bottom: "auto",
      position: "absolute",
      width: overlayWidth != null ? overlayWidth : overlayMatchTriggerWidth ? triggerWidth : "auto",
      minWidth: overlayMinTriggerWidth ? triggerWidth : "auto"
    }
  }, overlayAriaProps, overlayPositionProps);

  var variants = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalVariantProps)), mergeVariantToggles({
    def: config.isPlacedTopVariant,
    active: placementAxis === "top"
  }, {
    def: config.isPlacedBottomVariant,
    active: placementAxis === "bottom"
  }, {
    def: config.isPlacedLeftVariant,
    active: placementAxis === "left"
  }, {
    def: config.isPlacedRightVariant,
    active: placementAxis === "right"
  }));

  var args = _extends({}, pick.apply(void 0, [props].concat(plasmicClass.internalArgProps)), (_extends2 = {}, _extends2[config.contentSlot] = createElement(FocusScope, {
    restoreFocus: true
  }, createElement(DismissButton, {
    onDismiss: state.close
  }), children, createElement(DismissButton, {
    onDismiss: state.close
  })), _extends2));

  var overrides = (_overrides = {}, _overrides[config.root] = {
    props: mergeProps(overlayProps, getStyleProps(props), {
      ref: onOverlayRef
    }),
    wrap: function wrap(root) {
      return createPortal(root, document.body);
    }
  }, _overrides);
  return {
    plasmicProps: {
      variants: variants,
      args: args,
      overrides: overrides
    }
  };
}

function renderStack(as, props, hasGap, ref) {
  var children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["children"]);

  var wrappedChildren = wrapFlexContainerChildren(children, hasGap != null ? hasGap : false);
  return createElementWithChildren(as, _extends({
    ref: ref
  }, rest), wrappedChildren);
}

function FlexStack_(props, outerRef) {
  var as = props.as,
      hasGap = props.hasGap,
      rest = _objectWithoutPropertiesLoose(props, ["as", "hasGap"]);

  return renderStack(as != null ? as : "div", rest, hasGap, outerRef);
}

var FlexStack = /*#__PURE__*/forwardRef(FlexStack_);

var makeStackImpl = function makeStackImpl(as) {
  return forwardRef(function (props, ref) {
    var hasGap = props.hasGap,
        rest = _objectWithoutPropertiesLoose(props, ["hasGap"]);

    return renderStack(as, rest, hasGap, ref);
  });
};

var Stack = /*#__PURE__*/Object.assign(FlexStack, {
  div: /*#__PURE__*/makeStackImpl("div"),
  a: /*#__PURE__*/makeStackImpl("a"),
  button: /*#__PURE__*/makeStackImpl("button"),
  h1: /*#__PURE__*/makeStackImpl("h1"),
  h2: /*#__PURE__*/makeStackImpl("h2"),
  h3: /*#__PURE__*/makeStackImpl("h3"),
  h4: /*#__PURE__*/makeStackImpl("h4"),
  h5: /*#__PURE__*/makeStackImpl("h5"),
  h6: /*#__PURE__*/makeStackImpl("h6"),
  label: /*#__PURE__*/makeStackImpl("label"),
  form: /*#__PURE__*/makeStackImpl("form"),
  section: /*#__PURE__*/makeStackImpl("section"),
  head: /*#__PURE__*/makeStackImpl("head"),
  main: /*#__PURE__*/makeStackImpl("main"),
  nav: /*#__PURE__*/makeStackImpl("nav")
});

function hasVariant(variants, groupName, variant) {
  if (variants == null) {
    return false;
  }

  var groupVariants = variants[groupName];

  if (groupVariants == null) {
    return false;
  } else if (groupVariants === true) {
    return variant === groupName;
  } else if (groupVariants === false) {
    return false;
  } else if (Array.isArray(groupVariants)) {
    return groupVariants.includes(variant);
  } else if (typeof groupVariants === "string") {
    return groupVariants === variant;
  } else {
    return groupVariants[variant] !== undefined && groupVariants[variant] !== false;
  }
}

function wrapFlexContainerChildren(children, hasGap) {
  // We need to always wrap the children, even if there are no gaps, because
  // otherwise if we toggle between with and without gap, React reconciliation
  // will blow away the children tree and all state if we switch from having
  // a wrapper and not.
  var className = hasGap ? "__wab_flex-container" : "__wab_passthrough";

  if (!children) {
    return null;
  } else if (Array.isArray(children)) {
    return createElement.apply(React, ["div", {
      className: className
    }].concat(children));
  } else {
    return createElement("div", {
      className: className
    }, children);
  }
}

function createPlasmicElement(override, defaultRoot, defaultProps, wrapChildrenInFlex) {
  var override2 = deriveOverride(override);
  var props = mergeOverrideProps(defaultProps, override2.props);

  if (override2.type === "render") {
    return override2.render(props, defaultRoot);
  }

  var root = defaultRoot;

  if (override2.type === "as" && override2.as) {
    if (defaultRoot === Stack) {
      // If there was an "as" override specified, but the default type is
      // a Stack, then we don't want to switch to using "as" as the root,
      // because then we'd lose the flex wrapper that Stack provides.
      // Instead, we specify the "as" as the "as" prop to Stack.
      props.as = override2.as;
    } else {
      root = override2.as;
    }
  }

  var children = props.children;

  if (override2.wrapChildren) {
    children = override2.wrapChildren(ensureNotArray(children));
  }

  if (wrapChildrenInFlex) {
    // For legacy, we still support data-plasmic-wrap-flex-children
    children = wrapFlexContainerChildren(children, true);
  }

  var result = createElementWithChildren(root, props, children);

  if (override2.wrap) {
    result = override2.wrap(result);
  }

  return result;
} // We use data-plasmic-XXX attributes for custom properties since Typescript doesn't
// support type check on jsx pragma. See https://github.com/microsoft/TypeScript/issues/21699
// for more info.


var seenElements = /*#__PURE__*/new Map();

function createPlasmicElementProxy(defaultElement, props) {
  // We use seenElements to keep track of elements that has been rendered by
  // createPlasmicElementProxy().  When a JSX tree is evaluated, the JSX factory
  // is invoked from the leaf to the root as the last call.  So we can store
  // all the elements we've created until we encounter the leaf, at which point
  // we will clear this map.  We are guaranteed that this map will only contain
  // elements from one Plasmic* component at a time, because we're just creating
  // elements and not "rendering" at this point; even if this JSX tree references
  // other Plasmic* elements, we'll just create an element referencing that component,
  // rather than following into the content of that component.
  //
  // TODO: is this ConcurrentMode friendly?
  if (props == null) {
    props = {};
  }

  var name = props["data-plasmic-name"];
  var isRoot = props["data-plasmic-root"];
  var forNodeName = props["data-plasmic-for-node"];
  delete props["data-plasmic-name"];
  delete props["data-plasmic-root"];
  delete props["data-plasmic-for-node"];

  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  var element = createPlasmicElementFromJsx.apply(void 0, [defaultElement, props].concat(children));

  if (name) {
    seenElements.set(name, element);
  }

  if (isRoot) {
    var _seenElements$get; // If this is the root, and we requested a specific node by specifying data-plasmic-for-node,
    // then return that node instead


    var forNode = forNodeName ? (_seenElements$get = seenElements.get(forNodeName)) != null ? _seenElements$get : null : element; // Clear out the seenElements map, as we're done rendering this Plasmic* component.

    seenElements.clear();
    return forNode;
  }

  return element;
}

function createPlasmicElementFromJsx(defaultElement, props) {
  var _props$dataPlasmicT;

  var override = props["data-plasmic-override"];
  var wrapFlexChild = props["data-plasmic-wrap-flex-child"];
  var triggerProps = (_props$dataPlasmicT = props["data-plasmic-trigger-props"]) != null ? _props$dataPlasmicT : [];
  delete props["data-plasmic-override"];
  delete props["data-plasmic-wrap-flex-child"];
  delete props["data-plasmic-trigger-props"];

  for (var _len2 = arguments.length, children = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    children[_key2 - 2] = arguments[_key2];
  }

  return createPlasmicElement(override, defaultElement, mergeProps.apply(void 0, [props, children.length === 0 ? {} : {
    children: children
  }].concat(triggerProps)), wrapFlexChild);
}

function makeFragment() {
  for (var _len3 = arguments.length, children = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    children[_key3] = arguments[_key3];
  }

  return createElement.apply(React, [Fragment, {}].concat(children));
}

var UNSET = /*#__PURE__*/Symbol("UNSET");

function mergeOverrideProps(defaults, overrides) {
  if (!overrides) {
    return defaults;
  }

  var result = _extends({}, defaults);

  for (var _i = 0, _Object$keys = Object.keys(overrides); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var defaultVal = defaults[key];
    var overrideVal = overrides[key];

    if (overrideVal === UNSET) {
      delete result[key];
    } else {
      // We use the NONE sentinel if the overrideVal is nil, and is not one of the
      // props that we merge by default -- which are className, style, and
      // event handlers.  This means for all other "normal" props -- like children,
      // title, etc -- a nil value will unset the default.
      if (overrideVal == null && key !== "className" && key !== "style" && !(key.startsWith("on") && typeof defaultVal === "function")) {
        overrideVal = NONE;
      }

      result[key] = mergePropVals(key, defaultVal, overrideVal);
    }
  }

  return result;
}

function wrapWithClassName(element, className) {
  var key = isValidElement(element) ? element.key || undefined : undefined;
  return createElement("div", {
    key: key,
    className: className,
    style: {
      display: "grid"
    }
  }, element);
}

function deriveOverride(x) {
  if (!x) {
    // undefined Binding is an empty Binding
    return {
      type: "default",
      props: {}
    };
  } else if (isReactNode(x)) {
    // If ReactNode, then assume this is the children
    return {
      type: "default",
      props: {
        children: x
      }
    };
  } else if (typeof x === "object") {
    // If any of the overrideKeys is a key of this object, then assume
    // this is a full Override
    if ("as" in x) {
      return _extends({}, x, {
        props: x.props || {},
        type: "as"
      });
    } else if ("render" in x) {
      return _extends({}, x, {
        type: "render"
      });
    } else if ("props" in x) {
      return _extends({}, x, {
        props: x.props || {},
        type: "default"
      });
    } else if (isSubset(Object.keys(x), ["wrap", "wrapChildren"])) {
      // Only twiddling functions present, so assume no props overrides
      // (otherwise we'd assume these were props).
      return _extends({}, x, {
        props: {},
        type: "default"
      });
    } // Else, assume this is just a props object.


    return {
      type: "default",
      props: x
    };
  } else if (typeof x === "function") {
    return {
      type: "render",
      render: x
    };
  }

  throw new Error("Unexpected override: " + x);
}

function mergeVariants(v1, v2) {
  return _extends({}, v1, v2);
}

function mergeArgs(a1, a2) {
  return _extends({}, a1, a2);
}

function mergeFlexOverrides(o1, o2) {
  var keys = Array.from(new Set([].concat(Object.keys(o1), Object.keys(o2))));
  var merged = {};

  for (var _i2 = 0, _keys = keys; _i2 < _keys.length; _i2++) {
    var key = _keys[_i2];
    merged[key] = mergeFlexOverride(o1[key], o2[key]);
  }

  return merged;
}

function mergeFlexOverride(fo1, fo2) {
  var _o1$props, _ref;

  if (!fo1) {
    return fo2;
  }

  if (!fo2) {
    return fo1;
  }

  var o1 = deriveOverride(fo1);
  var o2 = deriveOverride(fo2);
  var wrap = chainSingleArgFuncs.apply(void 0, [o1.wrap, o2.wrap].filter(notNil));
  var wrapChildren = chainSingleArgFuncs.apply(void 0, [o1.wrapChildren, o2.wrapChildren].filter(notNil)); // "render" type always takes precedence, but we still merge the props

  var props = mergeOverrideProps((_o1$props = o1.props) != null ? _o1$props : {}, o2.props);

  if (o2.type === "render") {
    return {
      render: o2.render,
      props: props,
      wrap: wrap,
      wrapChildren: wrapChildren
    };
  }

  if (o1.type === "render") {
    return {
      render: o1.render,
      props: props,
      wrap: wrap,
      wrapChildren: wrapChildren
    };
  } // "as" will take precedence


  var as = (_ref = o2.type === "as" ? o2.as : undefined) != null ? _ref : o1.type === "as" ? o1.as : undefined;
  return _extends({
    props: props,
    wrap: wrap,
    wrapChildren: wrapChildren
  }, as ? {
    as: as
  } : {});
}

function deriveRenderOpts(props, config) {
  var _props$variants, _props$args, _props$overrides;

  var name = config.name,
      descendantNames = config.descendantNames,
      internalVariantPropNames = config.internalVariantPropNames,
      internalArgPropNames = config.internalArgPropNames;
  var reservedPropNames = ["variants", "args", "overrides"];
  var variants = mergeVariants(omit.apply(void 0, [pick.apply(void 0, [props].concat(internalVariantPropNames))].concat(reservedPropNames)), (_props$variants = props.variants) != null ? _props$variants : {});
  var args = mergeArgs(omit.apply(void 0, [pick.apply(void 0, [props].concat(internalArgPropNames))].concat(reservedPropNames)), (_props$args = props.args) != null ? _props$args : {});
  var overrides = mergeFlexOverrides(omit.apply(void 0, [pick.apply(void 0, [props].concat(descendantNames))].concat(internalArgPropNames, internalVariantPropNames, reservedPropNames)), (_props$overrides = props.overrides) != null ? _props$overrides : {});
  var leftoverProps = omit.apply(void 0, [props, "variants", "args", "overrides"].concat(descendantNames, internalVariantPropNames, internalArgPropNames));

  if (Object.keys(leftoverProps).length > 0) {
    var _mergeFlexOverrides;

    overrides = mergeFlexOverrides(overrides, (_mergeFlexOverrides = {}, _mergeFlexOverrides[name] = {
      props: leftoverProps
    }, _mergeFlexOverrides));
  }

  return {
    variants: variants,
    args: args,
    overrides: overrides
  };
}

var isDefaultValue = function isDefaultValue(val) {
  return val === "PLEASE_RENDER_INSIDE_PROVIDER";
};

var seenDefaultVariants = {};

function ensureGlobalVariants(globalVariantValues) {
  Object.entries(globalVariantValues).filter(function (_ref) {
    var value = _ref[1];
    return isDefaultValue(value);
  }).forEach(function (_ref2) {
    var key = _ref2[0];
    globalVariantValues[key] = undefined;

    if (!seenDefaultVariants[key] && process.env.NODE_ENV === "development") {
      seenDefaultVariants[key] = true;
      var providerName = "" + key[0].toUpperCase() + key.substring(1) + "Context.Provider";
      console.warn("Plasmic context value for global variant \"" + key + "\" was not provided; please use " + providerName + " at the root of your React app. Learn More: https://www.plasmic.app/learn/other-assets/#global-variants");
    }
  });
  return globalVariantValues;
}

function PlasmicIcon(props) {
  var PlasmicIconType = props.PlasmicIconType,
      rest = _objectWithoutPropertiesLoose(props, ["PlasmicIconType"]);

  return createElement(PlasmicIconType, Object.assign({}, rest));
}

function PlasmicLink(props) {
  // props.href is required for nextjs; if no props.href,
  // then we just render the default anchor element
  if (props.platform === "nextjs" && props.href) {
    var nextjsProps = ["href", "replace", "scroll", "shallow", "passHref", "prefetch", "locale"];
    return React__default.createElement(props.component, pick.apply(void 0, [props].concat(nextjsProps)), React__default.createElement("a", Object.assign({}, omit.apply(void 0, [props, "component", "platform"].concat(nextjsProps)))));
  }

  if (props.platform === "gatsby" && isInternalHref(props.href)) {
    return React__default.createElement(props.component, _extends({}, omit(props, "component", "platform", "href"), {
      to: props.href
    }));
  }

  return React__default.createElement("a", Object.assign({}, omit(props, "component", "platform")));
}

function isInternalHref(href) {
  return /^\/(?!\/)/.test(href);
}

function PlasmicSlot(props) {
  return renderPlasmicSlot(props);
}

function renderPlasmicSlot(opts) {
  var as = opts.as,
      defaultContents = opts.defaultContents,
      value = opts.value,
      rest = _objectWithoutPropertiesLoose(opts, ["as", "defaultContents", "value"]);

  var content = value === undefined ? defaultContents : value;

  if (!content || Array.isArray(content) && content.length === 0) {
    return null;
  } // If the content is a raw string, then we need to wrap the raw string
  // into an element, in case the slot is inside a flex-gap
  // container (you cannot apply margin to just a text node).


  var maybeString = maybeAsString(content);

  if (maybeString) {
    content = createElement("div", {
      className: "__wab_slot-string-wrapper"
    }, maybeString);
  }

  var nonEmptyProps = Object.keys(rest).filter(function (p) {
    return !!rest[p];
  });

  if (nonEmptyProps.length === 0) {
    // No attrs to apply to the slot (which means the slot is unstyled), then
    // just render the content directly; no need for style wrapper.
    return createElement(Fragment, null, content);
  }

  return createElement(as || "div", mergeProps({
    className: "__wab_slot"
  }, rest), content);
}

function maybeAsString(node) {
  // Unwrap fragments
  if (isValidElement(node) && node.type === Fragment) {
    return maybeAsString(node.props.children);
  }

  if (typeof node === "string") {
    return node;
  }

  if (Array.isArray(node) && node.length === 1 && typeof node[0] === "string") {
    return node[0];
  }

  return undefined;
}

var listeners = [];
var queries = {};

function matchScreenVariants() {
  if (!isBrowser) {
    return [];
  }

  return Object.entries(queries).filter(function (_ref) {
    var query = _ref[1];
    return window.matchMedia(query).matches;
  }).map(function (_ref2) {
    var name = _ref2[0];
    return name;
  });
} // undefined if screen variants have never been calculated


var curScreenVariants = undefined;

function recalculateScreenVariants() {
  var screenVariant = matchScreenVariants();

  if (!curScreenVariants || screenVariant.join("") !== curScreenVariants.join("")) {
    curScreenVariants = screenVariant;
    ReactDOM__default.unstable_batchedUpdates(function () {
      return listeners.forEach(function (listener) {
        return listener();
      });
    });
  }
}

function ensureInitCurScreenVariants() {
  // Initializes curScreenVariants if it hadn't been before. Note that this must
  // be called from within an effect.
  if (curScreenVariants === undefined) {
    curScreenVariants = matchScreenVariants();
  }
}

if (isBrowser) {
  window.addEventListener("resize", recalculateScreenVariants);
}

function createUseScreenVariants(isMulti, screenQueries) {
  Object.assign(queries, screenQueries);
  return function () {
    // It is important that upon first render, we return [] or undefined, because
    // that is what SSR will use, and the client must match.  In an effect (which
    // only happens on the client), we then actually ask for the real screen variant
    // and, if different from [] or undefined, forces a re-render.
    var _React$useState = useState(),
        updateState = _React$useState[1];

    var lastScreenVariantsRef = useRef(curScreenVariants || []); // We do useLayoutEffect instead of useEffect to immediately
    // register our forceUpdate. This ensures that if there was
    // a window resize event between render and effects, that the
    // listener will be registered in time

    useIsomorphicLayoutEffect(function () {
      var updateIfChanged = function updateIfChanged() {
        if (curScreenVariants && lastScreenVariantsRef.current.join("") !== curScreenVariants.join("")) {
          lastScreenVariantsRef.current = curScreenVariants; // Force update

          updateState({});
        }
      }; // Listeners are invoked whenever the window is resized


      listeners.push(updateIfChanged); // Initialize the curScreenVariants for the first time.  We don't need
      // to invoke the listeners here because all components will already
      // have this effect running and will re-render if the real screen
      // variant is non-empty.

      ensureInitCurScreenVariants(); // Now, if the curScreenVariants differs from what we returned last,
      // then force a re-render.

      updateIfChanged();
      return function () {
        // Remove our listener on unmount
        listeners.splice(listeners.indexOf(updateIfChanged), 1);
      };
    }, []);

    if (isMulti) {
      return curScreenVariants || [];
    } else if (curScreenVariants) {
      return curScreenVariants[curScreenVariants.length - 1];
    } else {
      return undefined;
    }
  };
}

function useFocused(opts) {
  var _useAriaFocusRing = useFocusRing({
    within: false,
    isTextInput: opts.isTextInput
  }),
      isFocused = _useAriaFocusRing.isFocused,
      focusProps = _useAriaFocusRing.focusProps;

  return [isFocused, focusProps];
}

function useFocusVisible(opts) {
  var _useAriaFocusRing2 = useFocusRing({
    within: false,
    isTextInput: opts.isTextInput
  }),
      isFocusVisible = _useAriaFocusRing2.isFocusVisible,
      focusProps = _useAriaFocusRing2.focusProps;

  return [isFocusVisible, focusProps];
}

function useFocusedWithin(opts) {
  var _useAriaFocusRing3 = useFocusRing({
    within: true,
    isTextInput: opts.isTextInput
  }),
      isFocused = _useAriaFocusRing3.isFocused,
      focusProps = _useAriaFocusRing3.focusProps;

  return [isFocused, focusProps];
}

function useFocusVisibleWithin(opts) {
  var _useAriaFocusRing4 = useFocusRing({
    within: true,
    isTextInput: opts.isTextInput
  }),
      isFocusVisible = _useAriaFocusRing4.isFocusVisible,
      focusProps = _useAriaFocusRing4.focusProps;

  return [isFocusVisible, focusProps];
}

function useHover() {
  var _React$useState = useState(false),
      isHover = _React$useState[0],
      setHover = _React$useState[1];

  return [isHover, {
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    }
  }];
}

function usePressed() {
  var _React$useState2 = useState(false),
      isPressed = _React$useState2[0],
      setPressed = _React$useState2[1];

  return [isPressed, {
    onMouseDown: function onMouseDown() {
      return setPressed(true);
    },
    onMouseUp: function onMouseUp() {
      return setPressed(false);
    }
  }];
}

var TRIGGER_TO_HOOK = {
  useHover: useHover,
  useFocused: useFocused,
  useFocusVisible: useFocusVisible,
  useFocusedWithin: useFocusedWithin,
  useFocusVisibleWithin: useFocusVisibleWithin,
  usePressed: usePressed
};
/**
 * Installs argment trigger. All the useTrigger calls must use hardcoded `trigger` arg,
 * as it's not valid to install variable React hooks!
 */

function useTrigger(trigger, opts) {
  return TRIGGER_TO_HOOK[trigger](opts);
} // Utilities used by generated code


var classNames = classNames$1;
export { DropdownMenu, PlasmicIcon, PlasmicLink, PlasmicSlot, Stack, classNames, createPlasmicElementProxy, createUseScreenVariants, deriveRenderOpts, ensureGlobalVariants, getDataProps, hasVariant, makeFragment, omit, pick, renderPlasmicSlot, setPlumeStrictMode, useCheckbox, useMenu, useMenuButton, useMenuGroup, useMenuItem, useSelect, useSelectOption, useSelectOptionGroup, useTrigger, useTriggeredOverlay, wrapWithClassName };